import { initTagManager, trackEvent } from "@/utils/tag-manager";
import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { AppProviders } from "@/core/providers";
import { AppRoutes } from "@/core/router";

function App() {
  useEffect(() => {
    initTagManager();
    trackEvent("Cronika | APP", "init", "app_initialized");
  }, []);

  return (
    <BrowserRouter basename="/app">
      <AppProviders>
        <div className="h-full w-full">
          <AppRoutes />
        </div>
      </AppProviders>
    </BrowserRouter>
  );
}

export default App;
